<template>
  <div :class="$style.icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
    >
      <path
        :class="$style[fillClass]"
        d="M14.9374 5.43365C13.4229 2.08052 10.5739 0 7.5 0C4.42607 0 1.57706 2.08052 0.0625918 5.43365C0.0213087 5.52386 0 5.62122 0 5.71964C0 5.81805 0.0213087 5.91541 0.0625918 6.00562C1.57706 9.35875 4.42607 11.4393 7.5 11.4393C10.5739 11.4393 13.4229 9.35875 14.9374 6.00562C14.9787 5.91541 15 5.81805 15 5.71964C15 5.62122 14.9787 5.52386 14.9374 5.43365ZM7.5 10.0094C5.11583 10.0094 2.87411 8.37212 1.57706 5.71964C2.87411 3.06715 5.11583 1.42991 7.5 1.42991C9.88417 1.42991 12.1259 3.06715 13.4229 5.71964C12.1259 8.37212 9.88417 10.0094 7.5 10.0094ZM7.5 2.85982C6.90686 2.85982 6.32705 3.02754 5.83387 3.34178C5.34069 3.65602 4.95631 4.10267 4.72933 4.62523C4.50234 5.14779 4.44295 5.72281 4.55867 6.27756C4.67438 6.83231 4.96001 7.34188 5.37942 7.74183C5.79883 8.14178 6.33319 8.41416 6.91493 8.5245C7.49667 8.63485 8.09966 8.57821 8.64765 8.36176C9.19564 8.14531 9.66401 7.77876 9.99354 7.30846C10.3231 6.83817 10.499 6.28525 10.499 5.71964C10.499 4.96116 10.183 4.23376 9.62058 3.69744C9.05817 3.16112 8.29537 2.85982 7.5 2.85982ZM7.5 7.14954C7.20343 7.14954 6.91352 7.06568 6.66694 6.90856C6.42035 6.75144 6.22816 6.52812 6.11466 6.26684C6.00117 6.00556 5.97148 5.71805 6.02933 5.44067C6.08719 5.1633 6.23 4.90851 6.43971 4.70854C6.64942 4.50856 6.9166 4.37237 7.20747 4.3172C7.49834 4.26203 7.79983 4.29035 8.07382 4.39857C8.34782 4.5068 8.58201 4.69007 8.74677 4.92522C8.91153 5.16037 8.99948 5.43683 8.99948 5.71964C8.99948 6.09887 8.8415 6.46257 8.56029 6.73073C8.27908 6.99889 7.89769 7.14954 7.5 7.14954Z"
        fill="#9EA6AC"
      />
    </svg>
  </div>
</template>

<script type="text/ecmascript-6">
import iconsMixins from './../icons.mixins'

export default {
  name: 'EyeIcon',

  mixins: [iconsMixins],

  data () {
    return {
      defaultStatusFill: {
        icon: 'grey-medium',
        bg: 'white'
      }
    }
  }
}
</script>

<style lang="scss" module>
@import 'mpl-css/lib/assets/global/variables/colors';
@import 'mpl-css/lib/assets/global/functions/index';

.icon {
  position: relative;
  width: rem(28);
  height: rem(28);
  svg {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
  }
}

@each $color, $value in $colors {
  .bg#{$color} {
    fill: $value;
  }
  .fill#{$color} {
    fill: $value;
  }
}
</style>
